<template>
  <div class="features-page">
    <!-- Header -->
    <section class="page-header">
      <div class="container">
        <h1>功能特性</h1>
        <p>深入了解 MookNote 的强大功能</p>
      </div>
    </section>

    <!-- Feature Detail: Movies -->
    <section class="feature-detail">
      <div class="container">
        <div class="detail-row">
          <div class="detail-content">
            <h2>观影记录</h2>
            <p class="detail-desc">记录你的观影历程，从经典老片到最新大片，每一部值得记住的电影都不会错过。</p>
            <div class="detail-features">
              <div class="df-item">
                <div class="df-icon">
                  <img src="../assets/icon/movies-1.png" class="fixed-size-image">
                </div>
                <div class="df-text">
                  <h4>三种观看状态</h4>
                  <p>已看、在看、想看，清晰分类管理你的观影清单</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <img src="../assets/icon/movies-2.png" class="fixed-size-image">
                </div>
                <div class="df-text">
                  <h4>评分系统</h4>
                  <p>为每部电影打分，记录你的真实感受，生成个人观影排行榜</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <img src="../assets/icon/movies-3.png" class="fixed-size-image">
                </div>
                <div class="df-text">
                  <h4>观影笔记</h4>
                  <p>记录观影心得、经典台词，让每一次观影都有收获</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <img src="../assets/icon/movies-4.png" class="fixed-size-image">
                </div>
                <div class="df-text">
                  <h4>海报展示</h4>
                  <p>精美的瀑布流布局展示电影海报，视觉体验更佳</p>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-visual">
            <div class="mockup-container">
              <div class="mockup-phone">
                <div class="mp-header">
                  <span>≡</span>
                  <span>观影</span>
                  <img src="../assets/icon/search.png" class="search-image" >
                </div>
                <div class="mp-tabs">
                  <span class="active">观影</span>
                  <span>阅读</span>
                  <span>笔记</span>
                </div>
                <div class="mp-filters">
                  <span class="active">已看</span>
                  <span>在看</span>
                  <span>想看</span>
                </div>
                <div class="mp-grid">
                  <div class="mp-card">
                    <div class="mp-card-img mp-card-img-1"></div>
                    <span>楚门的世界</span>
                    <small>★ 9.5</small>
                  </div>
                  <div class="mp-card">
                    <div class="mp-card-img mp-card-img-2"></div>
                    <span>我的三体</span>
                    <small>★ 9.0</small>
                  </div>
                  <div class="mp-card">
                    <div class="mp-card-img mp-card-img-3"></div>
                    <span>仙剑奇侠传</span>
                    <small>★ 9.0</small>
                  </div>
                  <div class="mp-card">
                    <div class="mp-card-img mp-card-img-4"></div>
                    <span>这个杀手不太冷</span>
                    <small>★ 8.9</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Feature Detail: Reading -->
    <section class="feature-detail alt">
      <div class="container">
        <div class="detail-row reverse">
          <div class="detail-content">
            <h2>阅读管理</h2>
            <p class="detail-desc">追踪你的阅读进度，建立个人书单，让每一本读过的书都有迹可循。</p>
            <div class="detail-features">
              <div class="df-item">
                <div class="df-icon" style="background-color: #FBFBFB;">
                  <img src="../assets/icon/book1.png" class="fixed-size-image">
                </div>
                <div class="df-text">
                  <h4>阅读状态追踪</h4>
                  <p>已读、在读、准备读，一目了然地管理你的阅读计划</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon" style="background-color: #FBFBFB;">
                  <img src="../assets/icon/book2.png" class="fixed-size-image">
                </div>
                <div class="df-text">
                  <h4>书籍信息</h4>
                  <p>记录作者、出版日期、简介等详细信息，打造个人书库</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon" style="background-color: #FBFBFB;">
                  <img src="../assets/icon/book3.png" class="fixed-size-image">
                </div>
                <div class="df-text">
                  <h4>读书笔记</h4>
                  <p>摘录金句，记录感悟，积累知识，让阅读更有价值</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon" style="background-color: #FBFBFB;">
                  <img src="../assets/icon/book4.png" class="fixed-size-image">
                </div>
                <div class="df-text">
                  <h4>阅读统计</h4>
                  <p>年度阅读报告，可视化展示阅读数据，见证成长轨迹</p>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-visual">
            <div class="mockup-container">
              <div class="mockup-phone">
                <div class="mp-header">
                  <span>≡</span>
                  <span>阅读</span>
                  <img src="../assets/icon/search.png" class="search-image" >
                </div>
                <div class="mp-tabs">
                  <span>观影</span>
                  <span class="active">阅读</span>
                  <span>笔记</span>
                </div>
                <div class="mp-filters">
                  <span>已读</span>
                  <span class="active">在读</span>
                  <span>想读</span>
                </div>
                <div class="mp-grid">
                  <div class="mp-card book">
                    <div class="mp-card-img mp-card-book-1"></div>
                    <span>黄金时代</span>
                    <small>★ 9.3</small>
                  </div>
                  <div class="mp-card book">
                    <div class="mp-card-img mp-card-book-2"></div>
                    <span>你的孤独，虽败犹荣</span>
                    <small>★ 9.4</small>
                  </div>
                  <div class="mp-card book">
                    <div class="mp-card-img mp-card-book-3"></div>
                    <span>周国平散文精选</span>
                    <small>★ 9.5</small>
                  </div>
                  <div class="mp-card book">
                    <div class="mp-card-img mp-card-book-4"></div>
                    <span>三体</span>
                    <small>★ 9.0</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Feature Detail: Notes -->
    <section class="feature-detail">
      <div class="container">
        <div class="detail-row">
          <div class="detail-content">
            <h2>笔记整理</h2>
            <p class="detail-desc">随时记录灵感和想法，支持图文混排和富文本编辑，让你的知识库井井有条。</p>
            <div class="detail-features">
              <div class="df-item">
                <div class="df-icon">
                  <img src="../assets/icon/note1.png" class="fixed-size-image">
                </div>
                <div class="df-text">
                  <h4>快速记录</h4>
                  <p>一键新建笔记，捕捉瞬间灵感，不错过任何有价值的想法</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                   <img src="../assets/icon/note2.png" class="fixed-size-image">
                </div>
                <div class="df-text">
                  <h4>标签分类</h4>
                  <p>多维度标签系统，灵活组织笔记，快速检索所需内容</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <img src="../assets/icon/note3.png" class="fixed-size-image">
                </div>
                <div class="df-text">
                  <h4>图文混排</h4>
                  <p>支持插入图片，丰富笔记内容，图文并茂记录生活</p>
                </div>
              </div>
              <div class="df-item">
                <div class="df-icon">
                  <img src="../assets/icon/note4.png" class="fixed-size-image">
                </div>
                <div class="df-text">
                  <h4>全文搜索</h4>
                  <p>快速定位所需内容，再长的笔记也能秒速找到</p>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-visual">
            <div class="mockup-container">
              <div class="mockup-phone">
                <div class="mp-header">
                  <span>≡</span>
                  <span>笔记</span>
                  <img src="../assets/icon/search.png" class="search-image" >
                </div>
                <div class="mp-tabs">
                  <span>观影</span>
                  <span>阅读</span>
                  <span class="active">笔记</span>
                </div>
                <div class="mp-notes">
                  <div class="note-item">
                    <p>那时，我认为人生在一场大雾之中，四顾茫茫，但是，如果你往前走，路就在脚...</p>
                    <div class="note-images">
                      <div class="n-img"></div>
                      <div class="n-img"></div>
                    </div>
                    <div class="note-meta">
                      <span>test</span>
                      <span>◷ 51分钟前</span>
                    </div>
                  </div>
                  <div class="note-item">
                    <p>定位文件 file-upload.php 和 file-upload-js.php。修改之前记得备份文件...</p>
                    <div class="note-meta">
                      <span>◷ 59分钟前</span>
                    </div>
                  </div>
                  <div class="note-item">
                    <p>家里有一个二十年前的主机，自从改成服务器之后加装了好几块硬盘使用...</p>
                    <div class="note-meta">
                      <span>◷ 1小时前</span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Additional Features -->
    <section class="additional-features">
      <div class="container">
        <h2 class="section-title animate-on-scroll">更多特性</h2>
        <p class="section-subtitle animate-on-scroll">不止记录，更是你的个人知识库</p>
        <div class="af-grid">
          <div class="af-card animate-on-scroll">
            <div class="af-icon">
              <img src="../assets/icon/data.png"  class="fixed-size-image">
            </div>
            <h3>数据统计</h3>
            <p>可视化展示观影、阅读、笔记的统计信息，包括月度热力图、年度回顾等，见证你的成长轨迹。</p>
          </div>
          <div class="af-card animate-on-scroll">
            <div class="af-icon">
              <img src="../assets/icon/save.png"  class="fixed-size-image">
            </div>
            <h3>本地备份</h3>
            <p>一键导出数据到本地，支持 ZIP 格式打包，数据完全自主可控，换机无忧。</p>
          </div>
          <div class="af-card animate-on-scroll">
            <div class="af-icon">
               <img src="../assets/icon/cloud.png"  class="fixed-size-image">
            </div>
            <h3>WebDAV 云备份</h3>
            <p>支持 WebDAV 协议，可将数据备份到个人云盘（如坚果云），多设备同步无忧。</p>
          </div>
          <div class="af-card animate-on-scroll">
            <div class="af-icon">
               <img src="../assets/icon/回收站.png"  class="fixed-size-image">
            </div>
            <h3>回收站</h3>
            <p>误删的内容可在回收站中找回，支持一键恢复，避免重要数据意外丢失。</p>
          </div>
          <div class="af-card animate-on-scroll">
            <div class="af-icon">
               <img src="../assets/icon/lock.png"  class="fixed-size-image">
            </div>
            <h3>隐私保护</h3>
            <p>所有数据本地存储，无需注册账号，不收集任何个人信息，你的隐私你做主。</p>
          </div>

          <div class="af-card animate-on-scroll">
            <div class="af-icon">
               <img src="../assets/icon/book3.png"  class="fixed-size-image">
            </div>
            <h3>EPUB 阅读器</h3>
            <p>内置 EPUB 电子书阅读器，支持导入本地书籍，自定义字体、字号、背景色，沉浸式阅读体验。</p>
          </div>
          <div class="af-card animate-on-scroll">
            <div class="af-icon">
               <img src="../assets/icon/note2.png"  class="fixed-size-image">
            </div>
            <h3>高级笔记</h3>
            <p>支持富文本编辑，图文混排、插入图片、格式化文本，满足更复杂的笔记需求。</p>
          </div>
          <div class="af-card animate-on-scroll">
            <div class="af-icon">
               <img src="../assets/icon/movies-2.png"  class="fixed-size-image">
            </div>
            <h3>豆瓣集成</h3>
            <p>通过 WebView 搜索豆瓣信息，一键获取电影、书籍的详细资料和评分。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Tech Stack -->
    <section class="tech-stack">
      <div class="container">
        <h2 class="section-title">技术栈</h2>
        <p class="section-subtitle">MookNote 基于现代技术构建</p>
        <div class="tech-grid">
          <div class="tech-item">
            <div class="tech-logo">F</div>
            <span>Flutter</span>
          </div>
          <div class="tech-item">
            <div class="tech-logo">D</div>
            <span>Dart</span>
          </div>
          <div class="tech-item">
            <div class="tech-logo">S</div>
            <span>SQFlite</span>
          </div>
          <div class="tech-item">
            <div class="tech-logo">P</div>
            <span>Provider</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Features'
}
</script>

<style scoped>
.search-image {
  width: 15px; 
  height: 15px;
}
.fixed-size-image {
  width: 20px; 
  height: 20px;
}

/* Page Header */
.page-header {
  padding: 100px 24px 60px;
  background: var(--color-bg-secondary);
  text-align: center;
}

.page-header h1 {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--color-text);
}

.page-header p {
  font-size: 17px;
  color: var(--color-text-secondary);
}

/* Feature Detail */
.feature-detail {
  padding: 100px 24px;
  background: white;
}

.feature-detail.alt {
  background: var(--color-bg-secondary);
}

.detail-row {
  display: flex;
  align-items: center;
  gap: 80px;
}

.detail-row.reverse {
  flex-direction: row-reverse;
}

.detail-content {
  flex: 1;
}

.detail-badge {
  display: inline-block;
  padding: 6px 14px;
  background: var(--color-bg-secondary);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-secondary);
  margin-bottom: 20px;
}

.detail-content h2 {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 20px;
  color: var(--color-text);
}

.detail-desc {
  font-size: 17px;
  color: var(--color-text-secondary);
  line-height: 1.8;
  margin-bottom: 40px;
}

.detail-features {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.df-item {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.df-icon {
  width: 40px;
  height: 40px;
  background: var(--color-bg-secondary); 
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}

.df-text h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
  color: var(--color-text);
}

.df-text p {
  font-size: 14px;
  color: var(--color-text-secondary);
}

.detail-visual {
  flex: 1;
  display: flex;
  justify-content: center;
}

/* Mockup Phone */
.mockup-container {
  perspective: 1000px;
}

.mockup-phone {
  width: 260px;
  background: white;
  border-radius: 24px;
  box-shadow: 0 25px 80px rgba(0,0,0,0.12);
  overflow: hidden;
  border: 8px solid var(--color-text);
}

.mp-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid var(--color-border);
}

.mp-tabs {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 12px 0;
  font-size: 13px;
  border-bottom: 1px solid var(--color-border);
}

.mp-tabs .active {
  font-weight: 600;
  position: relative;
}

.mp-tabs .active::after {
  content: '';
  position: absolute;
  bottom: -13px;
  left: 50%;
  transform: translateX(-50%);
  width: 16px;
  height: 2px;
  background: var(--color-text);
}

.mp-filters {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 14px 12px;
  font-size: 12px;
}

.mp-filters span {
  padding: 6px 12px;
  border-radius: 16px;
  background: var(--color-bg-secondary);
  color: var(--color-text-secondary);
}

.mp-filters .active {
  background: var(--color-text);
  color: white;
}

.mp-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 0 12px 16px;
}

.mp-grid.two-col {
  grid-template-columns: 1fr 1fr;
}

.mp-card {
  background: var(--color-bg-secondary);
  border-radius: 8px;
  overflow: hidden;
}

.mp-card div {
  aspect-ratio: 3/4;
}

.mp-card-img {
  background-size: cover;
  background-position: center;
}

.mp-card-img-1 {
  background-image: url('~@/assets/img/chumendeshijie.jpg');
}

.mp-card-img-2 {
  background-image: url('~@/assets/img/wodesanti.jpg');
}

.mp-card-img-3 {
  background-image: url('~@/assets/img/xianjianqixiazhuan.jpg');
}

.mp-card-img-4 {
  background-image: url('~@/assets/img/zhegeshashoubutaileng.jpg');
}

.mp-card-book-1 {
  background-image: url('~@/assets/img/book-s23122958.jpg');
}

.mp-card-book-2 {
  background-image: url('~@/assets/img/book-s27310359.jpg');
}

.mp-card-book-3 {
  background-image: url('~@/assets/img/book-s29628085.jpg');
}

.mp-card-book-4 {
  background-image: url('~@/assets/img/book-s29791128.jpg');
}

.mp-card span {
  display: block;
  padding: 6px 8px 2px;
  font-size: 11px;
  font-weight: 500;
}

.mp-card small {
  display: block;
  padding: 0 8px 8px;
  font-size: 10px;
  color: #FFB800;
}

.mp-notes {
  padding: 12px;
}

.note-item {
  background: var(--color-bg-secondary);
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
}

.note-item p {
  font-size: 12px;
  line-height: 1.6;
  color: var(--color-text);
  margin-bottom: 8px;
}

.note-images {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.n-img {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
}

.note-meta {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: var(--color-text-muted);
}

/* Additional Features */
.additional-features {
  padding: 100px 24px;
  background: white;
}

.af-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
}

.af-card {
  padding: 32px;
  background: var(--color-bg-secondary);
  border-radius: 16px;
  transition: transform 0.2s;
}

.af-card:hover {
  transform: translateY(-4px);
}

.af-icon {
  width: 48px;
  height: 48px;
  background: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 20px;
}

.af-card h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--color-text);
}

.af-card p {
  font-size: 14px;
  color: var(--color-text-secondary);
  line-height: 1.7;
}

/* Tech Stack */
.tech-stack {
  padding: 100px 24px;
  background: var(--color-bg-secondary);
  text-align: center;
}

.tech-grid {
  display: flex;
  justify-content: center;
  gap: 48px;
  flex-wrap: wrap;
  margin-top: 48px;
}

.tech-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.tech-logo {
  width: 72px;
  height: 72px;
  background: white;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 700;
  color: var(--color-text);
  box-shadow: 0 4px 12px rgba(0,0,0,0.06);
}

.tech-item span {
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-secondary);
}

/* Responsive */
@media (max-width: 968px) {
  .detail-row,
  .detail-row.reverse {
    flex-direction: column;
    gap: 48px;
  }

  .detail-content h2 {
    font-size: 28px;
  }

  .page-header h1 {
    font-size: 32px;
  }
}
</style>
